import React, { useEffect, useState } from 'react';

import StandardPageTemplate from '../../templates/StandardPage';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useMicrosoft } from '../../_libs/hooks/useMicrosoft';
import Subscription from '../../../src/models/subscription';
import MicrosoftSSOWidget from '../../molecules/MicrosoftSSOWidget';
import SubscriptionTable from '../../organisms/SubscriptionTable';

function fetchSubscriptions (cb: (subscriptions: any) => void) {
  // Add key and secret to publisher endpoint
  // Check for both when user tries to verify themselves as a publisher
  // When user verifies publisher access via active SSO, store in publisher and graphUser tables

  axios
    .get('/apis/microsoft/subscriptions/fetch/')
    .then(
      (res: AxiosResponse) => {
        if (res.data.status === 'OK') {
          const subscriptions = res.data.subscriptions;
          if (subscriptions) {
            cb(subscriptions);
          }
        } else {
          console.warn('Could not fetch subscriptions.');
        }
      },
      (err: AxiosError) => {
        console.error(err);
      },
    );
}

const PublisherSubscriptionsPage = (): JSX.Element => {
  const {
    error,
    graphData,
    isPublisher,
  } = useMicrosoft();
  const [subscriptions, setSubscriptions] = useState<Subscription[]>();
  useEffect(
    () => {
      if (graphData && isPublisher) {
        fetchSubscriptions(setSubscriptions);
      }
    }
  , [graphData, isPublisher]);

  let content = <p>Loading subscriptions...</p>;
  if (!graphData) {
    content = <MicrosoftSSOWidget error={error} type={'publisher'} />;
  } else if (subscriptions) {
    content = <SubscriptionTable subscriptions={subscriptions} userType="publisher" />;
  } else {
    content = <p>Could not find subscriptions associated with your account.</p>;
  }
  return (
    <StandardPageTemplate>
      <h1 className="f-serif f-normal f-italic">All Subscriptions</h1>
      {content}
    </StandardPageTemplate>
  );
};

export default PublisherSubscriptionsPage;
